import { __styles, mergeClasses } from '@griffel/react';
export const carouselClassNames = {
  root: 'fui-Carousel'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    B68tc82: "f1p9o1ba",
    Eiaeu8: "f1115ve7",
    qhf8xq: "f10pi13n"
  }
}, {
  d: [".f1p9o1ba{overflow-x:hidden;}", ".f1115ve7{overflow-anchor:none;}", ".f10pi13n{position:relative;}"]
});
/**
 * Apply styling to the Carousel slots based on the state
 */
export const useCarouselStyles_unstable = state => {
  'use no memo';

  const styles = useStyles();
  state.root.className = mergeClasses(carouselClassNames.root, styles.root, state.root.className);
  return state;
};